


document.addEventListener("DOMContentLoaded", function () {
  function updateSwatchDisplay() {
    const packColorFields = document.querySelectorAll('.variant-option-pack-color');

    packColorFields.forEach((field) => {
      const span = field.querySelector('.variant-option--swatches .variant-option__swatch-value');
      if (!span) return;

      const fullText = span.textContent.trim();
      const colors = fullText.split('|').map(c => c.trim());

      // Skip if already enhanced
      if (field.querySelector('.swatch-container')) return;

      // Create container
      const container = document.createElement('span');
      container.className = 'swatch-container';

      const shortList = colors.slice(0, 2).join(' | ');
      const remainingCount = colors.length - 2;
      const fullList = colors.join(' | ');

      const textSpan = document.createElement('span');
      textSpan.className = 'swatch-text';
      textSpan.textContent = shortList;

      const moreBtn = document.createElement('button');
      moreBtn.className = 'toggle-swatch';
      moreBtn.type = 'button';
      moreBtn.textContent = `+${remainingCount} more`;

      const hideBtn = document.createElement('button');
      hideBtn.className = 'toggle-swatch hide-btn';
      hideBtn.type = 'button';
      hideBtn.textContent = 'Hide';
      hideBtn.style.display = 'none';

      span.style.display = 'none';
      container.appendChild(textSpan);
      if (remainingCount > 0) {
        container.appendChild(moreBtn);
        container.appendChild(hideBtn);
      }
      span.parentNode.appendChild(container);

      // Toggle functionality
      moreBtn.addEventListener('click', function () {
        textSpan.textContent = fullList;
        moreBtn.style.display = 'none';
        hideBtn.style.display = 'inline-block';
      });

      hideBtn.addEventListener('click', function () {
        textSpan.textContent = shortList;
        moreBtn.style.display = 'inline-block';
        hideBtn.style.display = 'none';
      });
    });
  }

  // Run immediately – DOM is ready at DOMContentLoaded, no delay needed
  updateSwatchDisplay();

  // Re-run after Horizon's morph completes (variant:update fires after fetch + DOM diff)
  // This replaces the old 1500ms setTimeout race condition
  document.addEventListener('variant:update', function () {
    document.querySelectorAll('.variant-option-pack-color .swatch-container').forEach(c => c.remove());
    document.querySelectorAll('.variant-option-pack-color .variant-option__swatch-value').forEach(s => s.style.display = '');
    updateSwatchDisplay();
  });
});


document.addEventListener("DOMContentLoaded", function () {
    function toggleStickyCartOnScroll() {
      const stickyCart = document.querySelector('.sticky_cart_button');
      const variantPicker = document.querySelector('.variant-picker');
      const productInfo = document.querySelector('.product_information_section');
      if (!stickyCart || !variantPicker || !productInfo) return;
      const variantRect = variantPicker.getBoundingClientRect();
      const productInfoRect = productInfo.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      // CASE 1: If scrolled past product_information_section completely => show again
      if (productInfoRect.bottom < 0) {
        stickyCart.classList.remove('hide');
        return;
      }
      // CASE 2: If variant-picker bottom is visible => hide
      if (variantRect.bottom <= windowHeight && variantRect.bottom >= 0) {
        stickyCart.classList.add('hide');
        return;
      }
      // CASE 3: In all other cases => show
      stickyCart.classList.remove('hide');
    }
    window.addEventListener('scroll', toggleStickyCartOnScroll);
    window.addEventListener('resize', toggleStickyCartOnScroll);
    toggleStickyCartOnScroll(); // Initial run
});



document.addEventListener("DOMContentLoaded", function () {
  // Size chart open button
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".size_chart_btn a");
    if (btn) {
      e.preventDefault();
      const modal = document.querySelector(".size_chart_modal");
      if (modal) {
        modal.classList.add("is-visible");
      }
    }
  });

  // Close button
  document.addEventListener("click", function (e) {
    if (e.target.closest(".close")) {
      const modal = document.querySelector(".size_chart_modal");
      if (modal) {
        modal.classList.remove("is-visible");
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.size-tab-btn');
  const inTab = document.querySelector('.in-tab');
  const cmTab = document.querySelector('.cm-tab');

  if (buttons.length && (inTab || cmTab)) {
    buttons.forEach(btn => {
      btn.addEventListener('click', function () {
        buttons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        const tab = this.getAttribute('data-tab');
        if (tab === 'in') {
          if (inTab) inTab.style.display = 'block';
          if (cmTab) cmTab.style.display = 'none';
        } else if (tab === 'cm') {
          if (inTab) inTab.style.display = 'none';
          if (cmTab) cmTab.style.display = 'block';
        }
      });
    });
  }
});